<template>
  <v-container fluid fill-height>
    <v-layout>
      <v-flex xs12 sm12 md12>
        <v-card class="rounded-lg">
          <v-toolbar color="#f8f9fb" elevation="0">
            <v-toolbar-title>{{
              `${this.$t("notice.edit.title")}`
            }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn class="primary" @click="$router.go(-1)">
              <v-icon left> mdi-chevron-double-left </v-icon>
              {{ `${this.$t("notice.edit.buttons.back")}` }}
            </v-btn>
          </v-toolbar>
          <v-divider></v-divider>
          <v-card-text class="pa-10">
            <v-form>
              <v-row>
                <v-col cols="12" xs="12" sm="12" md="6">
                  <v-textarea
                    v-model="notice.title"
                    name="title"
                    label="Title"
                    rows="2"
                    v-validate="'required'"
                    :error="
                      errors.first('title') != null ||
                      serverSideErrors.title != null
                    "
                    :error-messages="
                      errors.first('title') || serverSideErrors.title
                    "
                  ></v-textarea>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" xs="12" sm="12" md="6">
                  <v-textarea
                    v-model="notice.description"
                    name="description"
                    label="Description"
                    v-validate="'required'"
                    rows="2"
                    :error="
                      errors.first('description') != null ||
                      serverSideErrors.description != null
                    "
                    :error-messages="
                      errors.first('description') ||
                      serverSideErrors.description
                    "
                  ></v-textarea>
                </v-col>
              </v-row>
               <v-row>
                <v-col cols="12" xs="12" sm="12" md="6">
                  <v-menu
                    ref="menu"
                    v-model="menu"
                    :close-on-content-click="false"
                    :return-value.sync="notice.expiry_date"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="notice.expiry_date"
                        label="Expiry Date"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        id="ExpiryDate"
                        name="ExpiryDate"
                        clearable
                        :error="
                          errors.first('ExpiryDate') != null ||
                          serverSideErrors.expiry_date != null
                        "
                        :error-messages="
                          errors.first('ExpiryDate') ||
                          serverSideErrors.expiry_date
                        "
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="notice.expiry_date"
                      no-title
                      scrollable
                    >
                      <v-spacer></v-spacer>
                      <v-btn
                        text
                        color="primary"
                        @click="menu = false"
                      >
                        Cancel
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.menu.save(notice.expiry_date)"
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                  <span
                    class="red--text"
                    v-if="
                      errors.first('ExpiryDate') ||
                      serverSideErrors.expiry_date
                    "
                  >
                    {{
                      errors.first("ExpiryDate") ||
                      serverSideErrors.expiry_date
                    }}
                  </span>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" xs="12" sm="12" md="6">
                  <v-file-input
                    v-model="notice.documents"
                    dense
                    label="Notice Document"
                    prepend-icon="mdi-camera"
                    multiple
                    :error="serverSideErrors.documents != null"
                    :error-messages="serverSideErrors.documents"
                    hint="Only jpg, png, gif, pdf, jpeg, svg file types are allowed"
                    persistent-hint
                    ><template v-slot:selection="{ text }">
                      <v-chip small label color="primary">
                        {{ text }}
                      </v-chip>
                    </template></v-file-input
                  >
                </v-col>
              </v-row>
              <v-row>
                <v-col
                  v-for="item in added_documents"
                  :key="item.document_url"
                  class="d-flex child-flex"
                  cols="2"
                >
                  <v-card>
                    <v-img
                      v-if="item.file_type == 'image'"
                      :src="API_BASE_URL + '/uploads/' + item.document_url"
                      :lazy-src="API_BASE_URL + '/uploads/' + item.document_url"
                      aspect-ratio="1"
                      class="grey lighten-2"
                    >
                      <template v-slot:placeholder>
                        <v-row
                          class="fill-height ma-0"
                          align="center"
                          justify="center"
                        >
                          <v-progress-circular
                            indeterminate
                            color="grey lighten-5"
                          ></v-progress-circular>
                        </v-row>
                      </template>
                    </v-img>
                    <v-img
                      v-else
                      :src="API_BASE_URL + '/default-pdf.png'"
                      :lazy-src="API_BASE_URL + '/default-pdf.png'"
                      aspect-ratio="1"
                      class="grey lighten-2"
                    >
                      <template v-slot:placeholder>
                        <v-row
                          class="fill-height ma-0"
                          align="center"
                          justify="center"
                        >
                          <v-progress-circular
                            indeterminate
                            color="grey lighten-5"
                          ></v-progress-circular>
                        </v-row>
                      </template>
                    </v-img>
                    <v-btn
                      icon
                      color="secondary"
                      name="delete_notice"
                      title="Edit Notice"
                      @click="confirmDelete(item.id)"
                    >
                      <v-icon small> mdi-close </v-icon>
                    </v-btn>
                    <v-btn
                      icon
                      color="secondary"
                      name="view_notice"
                      title="Edit "
                      @click="imgClick(item)"
                      style="float: right"
                    >
                      <v-icon small v-if="item.file_type == 'image'">
                        mdi-eye</v-icon
                      >
                      <v-icon small v-else> mdi-eye</v-icon>
                    </v-btn>
                  </v-card>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
          <v-card-actions class="pb-5">
            <v-btn
              color="secondary"
              dark
              class="px-8 ml-2"
              @click="saveNoticeDetail"
              :loading="loading"
              >Save</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-flex>
      <v-dialog v-model="imageDialog" max-width="100vh">
        <v-card>
          <v-btn
            icon
            color="secondary"
            name="delete_notice"
            title="Edit Notice"
            @click="imageDialog = false"
            style="float: right"
          >
            <v-icon small> mdi-close </v-icon>
          </v-btn>
          <v-card-title class="text-h5 grey lighten-2">
            <v-img
              :src="API_BASE_URL + '/uploads/' + image_url"
              :lazy-src="API_BASE_URL + '/uploads/' + image_url"
              aspect-ratio="1"
              class="grey lighten-2"
            ></v-img>
          </v-card-title>
        </v-card>
      </v-dialog>
      <v-dialog v-model="deleteDialog" width="500">
        <v-card>
          <v-card-title class="text-h5 grey lighten-2">
            Confirm!!
          </v-card-title>
          <v-card-text class="mt-2">Are you sure want to delete? </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="deleteDocument(delete_id)">
              yes
            </v-btn>
            <v-btn color="primary" text @click="closeDialog"> No </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </v-container>
</template>
<script>
import { mapMutations } from "vuex";
import moment from "moment";

// import moment from "moment";
export default {
  data() {
    return {
      user: {},
      loading: false,
      serverSideErrors: {},
      notice: {
        title: "",
        description: "",
        documents: [],
        expiry_date: '',
      },
      added_documents: [],
      delete_id: "",
      deleteDialog: false,
      imageDialog: false,
      image_url: "",
      base_url: process.env.VUE_APP_API_URL,
      menu: false,
    };
  },
  watch: {
    "notice.expiry_date": function() {
      console.log("this.notice.expiry_date",this.notice.expiry_date);
    }
  },
  methods: {
    ...mapMutations("alert", ["setAlert"]),
    removeAllFiles() {
      this.$refs.dropzone.removeAllFiles();
    },
    saveNoticeDetail() {
      let _self = this;
      this.$validator.validateAll().then((result) => {
        if (result) {
          _self.loading = true;
          let formData = new FormData();

          formData.append("title", this.notice.title);
          formData.append("description", this.notice.description);
          formData.append("expiry_date", this.notice.expiry_date ? moment.utc(this.notice.expiry_date).valueOf() : "");

          for (let i = 0; i < this.notice.documents.length; i++) {
            formData.append("documents[]", this.notice.documents[i]);
          }

          _self.$axios
            .put("/societyadmin/notices/" + this.notice.id, formData, {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            })
            .then((response) => {
              let data = response.data;

              _self.loading = false;
              _self.serverSideErrors = {};

              if (data.status) {
                this.setAlert({
                  showAlert: true,
                  message: data.message,
                  variant: "green accent-4",
                  timeout: 2000,
                });

                _self.$router.push({ path: "/societyadmin/notice" });
              } else {
                if (!data.errors) {
                  this.setAlert({
                    showAlert: true,
                    message: data.message,
                    variant: "red accent-3",
                    timeout: 2000,
                  });
                } else {
                  for (let i = 0; i < data.errors.length; i++) {
                    this.serverSideErrors[data.errors[i].field] =
                      data.errors[i].message;
                  }
                }
              }
            });
        }
      });
    },
    getNoticeDetail() {
      let _self = this;
      _self.$axios
        .get("societyadmin/notices/" + _self.$route.params.id)
        .then((response) => {
          let data = response.data;

          if (data.status) {
            _self.notice = data.notice;
             data.notice.expiry_date = data.notice.expiry_date ? moment(Number(data.notice.expiry_date)).format('YYYY-MM-DD') : null;
            this.notice.documents.map((x) => {
              x.name = x.document_url.replace("notice_documents/", "");
            });

            _self.added_documents = data.notice.documents;
          } else {
            if (data.errors) {
              _self.serverSideErrors = {};

              for (let i = 0; i < data.errors.length; i++) {
                _self.serverSideErrors[data.errors[i].field] =
                  data.errors[i].message;
              }
            } else {
              this.setAlert({
                showAlert: true,
                variant: "red accent-3",
                timeout: "2000",
                message: data.message,
              });
            }
          }
        });
    },
    confirmDelete(id) {
      (this.deleteDialog = true), (this.delete_id = id);
    },
    deleteDocument(Id) {
      let _self = this;
      _self.$axios
        .delete("societyadmin/notices/documents/" + Id)
        .then((response) => {
          let data = response.data;

          if (data.status) {
            console.log(data.status);
            this.getNoticeDetail();
            this.deleteDialog = false;
            this.setAlert({
              showAlert: true,
              variant: "green accent-4",
              timeout: "2000",
              message: data.message,
            });
          } else {
            this.setAlert({
              showAlert: true,
              variant: "red accent-3",
              timeout: "2000",
              message: data.message,
            });
          }
        });
    },
    closeDialog() {
      (this.deleteDialog = false), (this.delete_id = "");
    },
    imgClick(item) {
      // if (item.file_type == "image") {
      //   this.image_url = item.document_url;
      //   this.imageDialog = true;
      // } else {
        window.open(`${this.base_url}/uploads/${item.document_url}`, "_blank");
      // }
    },
  },
  mounted() {
    this.user = JSON.parse(localStorage.getItem("user"));
    this.getNoticeDetail();
  },
};
</script>
<style scoped>
.font-30 {
  font-size: 30px !important;
}
/* make the icon clickable in badge slot */
.edit-icon {
  z-index: 1000;
}
</style>